"use client";

import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Calendar } from "lucide-react";
import Image from "next/image";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";
import Link from "next/link";

export default function HeroSection() {
  const heroImages = ["/hero-1.png", "/hero-2.png", "/hero-3.png"];

  return (
    <section className="relative md:py-24 px-6 lg:px-8 overflow-hidden min-h-screen flex items-center">
      {/* Background Carousel */}
      <div className="mt-20 md:mt-0 absolute inset-0">
        <Carousel
          className="w-full h-[40vh] md:h-screen"
          plugins={[
            Autoplay({
              delay: 5000,
            }),
          ]}
          opts={{
            align: "start",
            loop: true,
          }}
        >
          <CarouselContent className="h-full">
            {heroImages.map((image, index) => (
              <CarouselItem key={index} className="h-full">
                <div className="relative w-full h-full">
                  <Image
                    src={image}
                    alt="Affaire Beauty Hero Image"
                    fill
                    className="object-cover"
                    priority={index === 0}
                  />
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>

        {/* Overlay for text readability */}
        <div className="hidden md:block absolute inset-0 bg-gradient-to-r from-white/95 via-white/40 to-white/10 z-10"></div>
      </div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto mt-[50vh] md:mt-0 w-full z-20">
        <div className="max-w-2xl">
          <div className="animate-fade-in">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-light text-stone-900 mb-8 tracking-tight leading-tight">
              Descubra a beleza
              <br />
              <span className="font-serif italic text-blush-600">
                natural da sua pele
              </span>
            </h1>

            <p className="md:text-xl text-stone-600 mb-12 leading-relaxed font-light">
              Dermocosmética portuguesa que celebra ingredientes únicos através
              de consultas personalizadas que transformam a sua rotina de
              cuidados.
            </p>
            {/* <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild>
                <Link href="/consultas">
                  <Calendar className="h-4 w-4" />
                  Marcar Consulta
                </Link>
              </Button>
              <Badge className="font-bold bg-blush-100 text-blush-700 border-0 px-4 py-2 rounded-full w-full md:w-auto">
                ✨ Campanha de Verão
              </Badge>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
}
